export default __webpack_public_path__ + "static/media/App_Store.d8297201.svg";